/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Razwan Shoket",
  title: "Hi all, I'm Razwan Shoket",
  subTitle: emoji(
    "A BCA Student from Jammu and Kashmir learning and working on different technologies"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1TdGplRDR2TLc6k3Hcm9Q_Jf2xOg3E8KJ/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/razwanshoket",
  linkedin: "https://www.linkedin.com/in/razwanshoket/",
  gmail: "razwanshokett@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=100075869588992",
  medium: "razwanshoket.medium.com",
  instagram: "https://instagram.com/razwanshoket",
  twitter: "https://twitter.com/RazwanShoket",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "A passionate learner, ambitious and driven student who loves to explore and work on exciting things!",
  skills: [
    emoji(
      "⚡ I'm a full-time Student pursuing my Bachelor Degree in Computer Applications from S.S. Jain Subodh P.G. Autonomous College Jaipur " ),
    emoji("⚡ Working on my own Startup 'Tribal Tech Sorts' which aims to connect Tribes living in remote areas of India with modern world technologies"),
    emoji(
      "⚡ Learning different technologies with Cyber Security as a main-stream. Currently working on Open Source Projects, Designing and Development, Blockchain"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "S.S. Jain Subodh P.G. Autonomous College Jaipur, Rajasthan, India",
      logo: require("./assets/images/Subodh_College_Logo.jpg"),
      subHeader: "Bachelor of Computer Applications",
      duration: "May 2021 - June 2024",
    },
    {
      schoolName: "Government Model Higher Secondary School Lamberi, Nowshera, J&K, India",
      logo: require("./assets/images/jkboselogo.png"),
      subHeader: "(10+2) Science with Computer Science",
      duration: "Completed in 2021",
      desc: "Completed my Higher Secondary Schooling from Government Model Higher Secondary School Lamberi, J&K in Science along with Computer Science",
    },
    {
      schoolName: "ST. Joseph's Convent High School Rajouri, J&K, India",
      logo: require("./assets/images/conventlogo.jpg"),
      subHeader: "(10th) High School",
      duration: "Completed in 2019",
      desc: "Completed my High School from St. Joseph's Convent High School Rajouri, J&K in 2019",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Leadership", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Grapic Designing",
      progressPercentage: "92%"
    },
    {
      Stack: "Communication",
      progressPercentage: "80%"
    },
    {
      Stack: "Computer Literacy",
      progressPercentage: "95%"
    },
    {
      Stack: "Time Management",
      progressPercentage: "85%"
    },
    {
      Stack: "Documentation",
      progressPercentage: "75%"
    },
    {
      Stack: "Problem Solving",
      progressPercentage: "80%"
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Founder and CEO",
      company: "Tribal Tech Sorts",
      companylogo: require("./assets/images/ttslogo.png"),
      date: "2020 – Present",
      desc: "My own Startup which works on Tribal Upliftment and Promotion. Scroll down to Projects Section to know more about Tribal Tech Sorts",
    },
    {
      role: "Campus Ambassador",
      company: "TechLearn.live",
      companylogo: require("./assets/images/techlearnlogo.jpg"),
      date: "2021",
      desc: "Worked as a Campus Ambassador for TechLearn in Global Groups of Institute Amritsar, Punjab. India"
    },
    {
      role: "Social Media and Content Manager",
      company: "Roodad-e-Qaum",
      companylogo: require("./assets/images/agzalogo.jpg"),
      date: "2019 - Present",
      desc: "Awaaz-e_Gujjar/Roodad-e-Qaum is a organization working under the sponsorship of Anjuman Gojri Zaban-o-Adab Dhramsall Kalakote, J&K, India which is a registered NGO. Roodad-e-Qaum publish a Monthly Magazine on the Gujjar and Bakerwal Tribe of Jammu and Kashmir"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Startup and the Projects I'm working on",
  projects: [
    {
      image: require("./assets/images/ttslogo.png"),
      projectName: "Tribal Tech Sorts",
      projectDesc: "Tribal Tech Sorts is my own startup which works on connecting Tribes living in remote areas of India with Modern World Technologies. TTS also works on upliftment, promotion and preservation of their culture and Livilihood",
      footerLink: [
        {
          name: "Want to discuss more, Connect with me on Whatsapp!",
          url: "https://wa.me/+917006454402"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/agzalogo.jpg"),
      projectName: "Agza Web Project",
      projectDesc: "Agza Web Project is the first full fledged Gojri (A language spoken by Gujjar and Bakerwal Tribal Communities) Website which will contain all the details of Gojri and Bakerwali Language as well as the lifestyle of these People",
      footerLink: [
        {
          name: "Connect me on Whatsapp to know more!",
          url: "https://wa.me/+917006454402"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Stuff that I have done !",

  achievementsCards: [
    {
      title: "Generic Training in Cyber Security",
      subtitle:
        "Basic Training in Cyber Security by Ministry of Electronics & Information Technology (MeitY), Government of India",
      image: require("./assets/images/meitlogo.jpg"),
      imageAlt: "meit-logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1PKk_Oy6wmt4HM5-Wb8ad9lEwLGn2Ch2Q/view?usp=sharing"
        },
      ]
    },
    {
      title: "Nation-Wide Financial Markets Quiz",
      subtitle:
        "Participated in Nation-Wide Financial Markets Quiz organized by Securities and Exchange Board of India and Securities Board of India",
      image: require("./assets/images/SEBI_logo.svg.png"),
      imageAlt: "sebi-logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1rvF_QdUDxDf2xN2Ih3BKHJBC8H5m1rdY/view?usp=sharing"
        }
      ]
    },

    {
      title: "Satellite Program by CU-SAT",
      subtitle: "Participated in Student Satellite Program organized by Chandigarh University under the mentorship of Padma Shri Dr. YS Rajan, Padma Shri Dr. Mylswamy Annadurai and Padma Shri Prof. RM Vasagam",
      image: require("./assets/images/culogo.png"),
      imageAlt: "cu-logo",
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1yPMOabMRTnGnBIMOa6_aw7Ir5iNFsScb/view?usp=sharing"},
      ]
    },
    {
      title: "Fundamentals of Digital Marketing",
      subtitle: "Completed my course on Fundamentals of Digital Marketing by Google",
      image: require("./assets/images/Google__G__Logo.svg.webp"),
      imageAlt: "google-logo",
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1GujUaPAR9TKPIguerW_YOwXOFkHBGVlA/view?usp=sharing"},
      ]
    },
    {
      title: "AI for India by Guvi",
      subtitle: "Participated in AI for India organized by GUVI India under Building a Face Recognization Application using Python Domain",
      image: require("./assets/images/guvilogo.png"),
      imageAlt: "guvi-logo",
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1OYbj_vxvJVP2e5cw1IU0XoHCwfUkDmbj/view?usp=sharing"},
      ]
    },
    {
      title: "Campus Ambassador",
      subtitle: "Worked as a Campus Ambassador for Tech Learn in Global Group of Institutes Amritsar, Punjab, India",
      image: require("./assets/images/techlearnlogo.jpg"),
      imageAlt: "techlearn-logo",
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1iE68V0Ef_jqBfUlMr5ppiT88djP0fQ0O/view?usp=sharing"},
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want to discuss something or just want to say hi? My Inbox is open for all. Feel free to connect with me on any of my Social Media or text me on the given Number or Email",
  number: "+91-7006454402",
  email_address: "razwanshokett@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "RazwanShoket", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
